import React, { useEffect, useRef, useState } from 'react';
import { List } from '@mui/material';
import { FilterTab } from './FilterTab';
import { DiscoveryFilter, FilterItem } from '../../../data/filters/discovery.data';
import { FilterValueSet } from '../../../redux/appConfigurator/types';
import { MapModal } from '../../MapModal/MapModal';
import { isEmpty } from '../../../utils/lodash';

interface IToggleFilter {
    onFilterPressed?: (...args: any) => void;
    filterList: DiscoveryFilter[];
    onFilterSelect: (categoryName: string, filterItem: FilterItem, categoryId: number) => void;
    filterSelections: FilterValueSet;
    open: boolean;
    selectedFilterSubCategoryId?: number | null;
}

const EsMappedFilters: React.FC<IToggleFilter> = ({
    onFilterPressed,
    filterList,
    onFilterSelect,
    filterSelections,
    open,
    selectedFilterSubCategoryId,
}) => {
    const [currentOpenFilter] = useState<any>(null);
    const [filters, setFilters] = useState<DiscoveryFilter[]>([]);
    const [openMap, setOpenMap] = useState(false);
    const ref = useRef(null);

    const handleToggleFilter = (index: number, filterGroupId?: number) => {
        if (onFilterPressed) onFilterPressed(currentOpenFilter, filterGroupId);
    };

    useEffect(() => {
        if (filterList) {
            setFilters(filterList);
        }
    }, [filterList, filters]);

    return (
        <List
            sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                flexDirection: 'row',
                gap: '15px',
                mr: 1,
                // width: '100%',
            }}>
            <MapModal
                isOpen={openMap}
                onClose={() => setOpenMap(!openMap)}
                onSelectClick={({ addressDescription, coord }) => {
                    onFilterSelect(
                        'Select Location', // Change these and fetch them dynamically
                        {
                            displayName: addressDescription,
                            field: 'Location',
                            parentId: 8,
                            value: {
                                longitude: coord[0],
                                latitude: coord[1],
                            },
                        },
                        8,
                    );
                    setOpenMap(!openMap);
                }}
            />
            {!!filterList &&
                !isEmpty(filterList) &&
                filterList?.map((filter, index) => {
                    const selected =
                        !isEmpty(filterSelections) &&
                        filterSelections[filter.id] &&
                        filterSelections[filter.id].displayName
                            ? filterSelections[filter.id].displayName
                            : filter.categoryName;
                    return (
                        <FilterTab
                            category={(selected as string) ?? ''}
                            ref={ref}
                            data={filter}
                            key={index.toString()}
                            selectedValue={selected}
                            open={selectedFilterSubCategoryId === filter.id}
                            onFilterPressed={(filterGroupId, extraDetails) => {
                                if (
                                    extraDetails &&
                                    extraDetails.categoryName &&
                                    extraDetails.categoryName.toLowerCase() === 'select location'
                                ) {
                                    setOpenMap(!openMap);
                                } else {
                                    handleToggleFilter(index, filterGroupId);
                                    handleToggleFilter(index, filterGroupId);
                                }
                            }}
                            onFilterSelect={(selection, categoryId) => {
                                onFilterSelect(filter.categoryName, selection, categoryId);
                            }}
                        />
                    );
                })}
        </List>
    );
};

export { EsMappedFilters };
